import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const get = (path, params) => axios.get(`${API}${path}`, { params }).then((r) => r.data);

export const getDashboard = () => get("/dashboard");
export const getRouteDetail = (id) => get(`/routes/${id}`);
export const getNews = () => get("/news");
export const getEvents = () => get("/events");
export const getIncidents = () => get("/incidents");
export const getWeather = () => get("/weather");
export const getBriefing = (refresh = false) => get("/ai-briefing", { refresh });

export const reportIncident = (payload) =>
  axios.post(`${API}/incidents/report`, payload).then((r) => r.data);

// Field officer app + dispatch
export const getDispatches = (unitId, active = true) => get("/dispatch", { unit_id: unitId, active });
export const createDispatch = (body) => axios.post(`${API}/dispatch`, body).then((r) => r.data);
export const updateDispatch = (id, body) => axios.patch(`${API}/dispatch/${id}`, body).then((r) => r.data);
export const uploadIncidentPhoto = (file) => {
  const fd = new FormData();
  fd.append("file", file);
  return axios.post(`${API}/upload/incident-photo`, fd, { headers: { "Content-Type": "multipart/form-data" } }).then((r) => r.data);
};
export const fileUrl = (path) => `${API}/files/${path}`;
export const verifyIncident = (id) =>
  axios.patch(`${API}/incidents/${id}/verify`).then((r) => r.data);
export const escalateIncident = (id) =>
  axios.patch(`${API}/incidents/${id}/escalate`).then((r) => r.data);
export const dismissIncident = (id) =>
  axios.delete(`${API}/incidents/${id}`).then((r) => r.data);

export const getAccuracy = () => get("/accuracy");
export const getLearning = () => get("/learning");
export const getReplay = (minutes = 180) => get("/replay", { minutes });
export const getSchools = () => get("/schools");
export const getCyber = () => get("/cyber");
export const getMedical = () => get("/medical");
export const getEnergy = () => get("/energy");
export const getResilience = () => get("/resilience");
export const getResilienceHistory = (hours = 24) => get(`/resilience/history?hours=${hours}`);
export const askAi = (payload) => axios.post(`${API}/ask`, payload).then((r) => r.data);
export const getCascade = () => get("/cascade");
export const activateCascade = (payload) => axios.post(`${API}/cascade/activate`, payload).then((r) => r.data);
export const getBrain = () => get("/brain");
export const brainAsk = (payload) => axios.post(`${API}/brain/ask`, payload).then((r) => r.data);
export const brainSpeak = (payload) => axios.post(`${API}/brain/speak`, payload).then((r) => r.data);
export const getBrainAlerts = () => get("/brain/alerts");
export const dispatchBrainAlert = (id) => axios.post(`${API}/brain/alerts/${id}/dispatch`).then((r) => r.data);
export const ttsUrl = (path) => `${process.env.REACT_APP_BACKEND_URL}${path}`;
export const getFlights = () => get("/flights");
export const getHazards = () => get("/hazards");
export const getRadio = () => get("/radio");
export const getRoute = (origin, destination) => get("/route", { origin, destination });
export const placeAutocomplete = (q) => get("/places/autocomplete", { q });

// Public /go app
export const getGoSummary = () => get("/go/summary");
export const getGoRoute = (origin, destination) => get("/go/route", { origin, destination });
export const getGoWeather = () => get("/go/weather");
export const getResources = () => get("/resources");
export const updateUnit = (id, body) => axios.patch(`${API}/resources/${id}`, body).then((r) => r.data);
export const simulateScenario = (payload) => axios.post(`${API}/scenario/simulate`, payload).then((r) => r.data);
export const fireNationalAlert = (payload) => axios.post(`${API}/alert/national`, payload).then((r) => r.data);
export const getMessages = (box) => get("/messages", box ? { box } : undefined);
export const sendMessage = (payload) => axios.post(`${API}/messages`, payload).then((r) => r.data);

export const getAnnouncements = () => get("/announcements");
export const createAnnouncement = (payload) => axios.post(`${API}/announcements`, payload).then((r) => r.data);
export const cancelAnnouncement = (id) => axios.delete(`${API}/announcements/${id}`).then((r) => r.data);
export const flightLogoUrl = (name) => `${API}/flights/logo/${encodeURIComponent(name)}`;

export default API;
